module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-download-screen'), _vm._v(" "), (_vm.view === null) ? _c('modal', {
    attrs: {
      "title": _vm.modalTitleCreate,
      "open": _vm.isOpen,
      "buttons": false
    },
    on: {
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('div', {
    staticClass: "action-box",
    attrs: {
      "data-action": "lead.create-from-email"
    },
    on: {
      "click": function($event) {
        return _vm.changeView('email')
      }
    }
  }, [_c('img', {
    staticClass: "enter-email",
    attrs: {
      "src": require("../../../../assets/enter-email.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("models.project_lead.message.create_from_email")))])]), _vm._v(" "), (
    _vm.browser.name == 'crios' ||
    _vm.browser.name == 'fxios' ||
    _vm.browser.name == 'ios'
  ) ? _c('div', {
    staticClass: "ios-workaround"
  }, [_c('label', {
    staticClass: "action-box",
    attrs: {
      "for": "businesscard_upload",
      "data-action": "lead.create-from-card"
    }
  }, [_c('img', {
    staticClass: "capture-card",
    attrs: {
      "src": require("../../../../assets/scan-card.svg")
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "ios_only ios-photo-input",
    attrs: {
      "id": "businesscard_upload",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": _vm.uploadedImage
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("models.project_lead.message.create_from_card")))])])]) : _c('div', [_c('div', {
    staticClass: "action-box",
    attrs: {
      "data-action": "lead.create-from-card"
    },
    on: {
      "click": function($event) {
        return _vm.changeView('card')
      }
    }
  }, [_c('img', {
    staticClass: "capture-card",
    attrs: {
      "src": require("../../../../assets/scan-card.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("models.project_lead.message.create_from_card")))])])])]) : (_vm.view === 'email') ? _c('modal', {
    attrs: {
      "title": _vm.modalTitleCreate,
      "saveText": _vm.modalSaveTextEmail,
      "open": _vm.isOpen
    },
    on: {
      "save": _vm.confirmEmail,
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "name": "email",
      "placeholder": "lead@company.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1) : (_vm.view === 'card') ? _c('modal', {
    staticClass: "lead-create-modal",
    attrs: {
      "title": _vm.modalTitleCreate,
      "open": _vm.isOpen,
      "saveText": _vm.modalSaveTextWebcam
    },
    on: {
      "save": _vm.takePhoto,
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('vue-webcam', {
    ref: "webcam"
  })], 1) : (_vm.view === 'api-error') ? _c('modal', {
    attrs: {
      "title": _vm.$t('errors.api_error_modal.select_company'),
      "saveText": _vm.modalSaveTextContinue,
      "open": _vm.isOpen
    },
    on: {
      "save": function($event) {
        return _vm.resolveApiError(true)
      },
      "cancel": function($event) {
        return _vm.setIsOpen(false)
      }
    }
  }, [_c('user-api-choice', {
    attrs: {
      "error": _vm.apiError,
      "listItems": _vm.apiErrorAttributes,
      "includeCtaButton": true,
      "ctaButtonText": "Continue",
      "caption": _vm.$t('errors.api_error_modal.select_company_caption')
    },
    on: {
      "resolve": _vm.resolveApiError
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdc78956","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadCreate.vue
// module id = 1985
// module chunks = 0